Controller.$inject = ['$element', '$timeout', '$transclude'];

function Controller($element, $timeout, $transclude) {
    let self = this;
    self.autoClose = true;

    self.handleClick = (event) => {
        if (!self.autoClose) {
            event.stopPropagation();
        }

        if (self.itemClick) {
            self.itemClick();
        }
    };

    self.$postLink = () => {
        $timeout(() => {
            const menuItemIconWrapper = $element[0].querySelector('.hui-menu-item-icon');

            if (!$transclude.isSlotFilled('icon')) {
                if (menuItemIconWrapper) {
                    angular.element(menuItemIconWrapper).css('display', 'none');
                }
            } else {
                const menuItemIconElement = menuItemIconWrapper?.querySelector('hui-menu-item-icon');

                if (menuItemIconElement?.classList.contains('d-none')) {
                    angular.element(menuItemIconWrapper).css('display', 'none');
                } else {
                    angular.element(menuItemIconWrapper).css('display', 'inline-flex');
                }
            }
        });
    };
}

export function HuiMenuItem() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            description: '@?',
            active: '<',
            multiElements: '<',
            autoClose: '<',
            itemClick: '&?'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            icon: '?huiMenuItemIcon'
        },
        template: ($element, $attrs) => {
            let tag = $attrs['uiSref'] || $attrs['href'] || $attrs['ngHref'] ? 'a' : 'button';

            if ($attrs['multiElements'] === "true") {
                tag = 'div';
            }

            let clickAttr = $attrs.autoClose === "false" ? 'ng-click="$huiCtrl.handleClick($event)"' : '';

            return `
                 <${tag} class="hui-menu-item"
                         ${clickAttr}
                         ng-class="{'active': $huiCtrl.active }">
                     <span class="hui-menu-item-icon" ng-transclude ng-transclude-slot="icon"></span>
                     <div class="w-100">
                          <div ng-class="{'item-label': !!$huiCtrl.description, 
                                          'd-flex justify-content-between align-items-center gap-1 multi-elements-menu-item': !!$huiCtrl.multiElements }" ng-transclude></div>
                          <div class="desc" ng-if="$huiCtrl.description">{{$huiCtrl.description}}</div>
                     </div>
                     <div class="check-wrapper">
                          <i class="fa fa-check text-primary"></i>
                     </div>
                 </${tag}>
            `;
        }
    }
}